import React from 'react';
import { Loader2, Upload, Save, RefreshCw, Sparkles } from 'lucide-react';

/**
 * Reusable form component for user intelligence input
 * Can be used in both onboarding and settings pages
 */
export default function UserIntelligenceForm({
  inputData,
  onInputChange,
  onGenerate,
  onUpdate,
  onRegenerate,
  generating,
  updating,
  exists,
  showActions = true,
  customActions = null
}) {
  return (
    <div className="rounded-xl shadow-sm border p-8" style={{ backgroundColor: '#FFFFFF', borderColor: '#D7B472' }}>
      <div className="flex items-center gap-2 mb-4">
        <Upload className="w-5 h-5" style={{ color: '#FF6B5A' }} />
        <h2 className="text-2xl font-semibold" style={{ color: '#0A0A10' }}>
          {exists ? 'Update Your Data' : 'Add Your Data'}
        </h2>
      </div>
      <p className="text-sm mb-6" style={{ color: '#0A0A10', opacity: 0.7 }}>
        Paste your call transcripts, emails, or any communication samples to help AI understand your style.
      </p>
      
      <textarea
        value={inputData}
        onChange={(e) => onInputChange(e.target.value)}
        placeholder="Paste your transcripts, emails, or communication samples here...&#10;&#10;Example:&#10;- Meeting transcripts&#10;- Email conversations&#10;- Sales call notes&#10;- Client communications"
        className="w-full h-96 p-4 rounded-lg border outline-none resize-none"
        style={{ 
          borderColor: '#D7B472',
          backgroundColor: '#F8F7F4',
          color: '#0A0A10'
        }}
        onFocus={(e) => { e.currentTarget.style.borderColor = '#FF6B5A'; }}
        onBlur={(e) => { e.currentTarget.style.borderColor = '#D7B472'; }}
      />

      {showActions && (
        <div className="flex gap-3 mt-6">
          {customActions ? (
            customActions
          ) : !exists ? (
            <button
              onClick={onGenerate}
              disabled={generating || !inputData.trim()}
              className="flex-1 flex items-center justify-center gap-2 px-6 py-3 rounded-lg font-semibold transition-all disabled:opacity-50 disabled:cursor-not-allowed"
              style={{ backgroundColor: '#FF6B5A', color: 'white' }}
              onMouseEnter={(e) => { 
                if (!generating && inputData.trim()) e.currentTarget.style.backgroundColor = '#e55a4a'; 
              }}
              onMouseLeave={(e) => { 
                if (!generating) e.currentTarget.style.backgroundColor = '#FF6B5A'; 
              }}
            >
              {generating ? (
                <>
                  <Loader2 className="w-5 h-5 animate-spin" />
                  Generating...
                </>
              ) : (
                <>
                  <Sparkles className="w-5 h-5" />
                  Generate Intelligence
                </>
              )}
            </button>
          ) : (
            <>
              <button
                onClick={onUpdate}
                disabled={updating || !inputData.trim()}
                className="flex-1 flex items-center justify-center gap-2 px-6 py-3 rounded-lg font-semibold transition-all disabled:opacity-50 disabled:cursor-not-allowed"
                style={{ backgroundColor: '#D7B472', color: 'white' }}
                onMouseEnter={(e) => { 
                  if (!updating && inputData.trim()) e.currentTarget.style.backgroundColor = '#c7a462'; 
                }}
                onMouseLeave={(e) => { 
                  if (!updating) e.currentTarget.style.backgroundColor = '#D7B472'; 
                }}
              >
                {updating ? (
                  <>
                    <Loader2 className="w-5 h-5 animate-spin" />
                    Updating...
                  </>
                ) : (
                  <>
                    <Save className="w-5 h-5" />
                    Update Data
                  </>
                )}
              </button>
              <button
                onClick={onRegenerate}
                disabled={generating || !inputData.trim()}
                className="flex-1 flex items-center justify-center gap-2 px-6 py-3 rounded-lg font-semibold transition-all disabled:opacity-50 disabled:cursor-not-allowed"
                style={{ backgroundColor: '#FF6B5A', color: 'white' }}
                onMouseEnter={(e) => { 
                  if (!generating && inputData.trim()) e.currentTarget.style.backgroundColor = '#e55a4a'; 
                }}
                onMouseLeave={(e) => { 
                  if (!generating) e.currentTarget.style.backgroundColor = '#FF6B5A'; 
                }}
              >
                {generating ? (
                  <>
                    <Loader2 className="w-5 h-5 animate-spin" />
                    Regenerating...
                  </>
                ) : (
                  <>
                    <RefreshCw className="w-5 h-5" />
                    Regenerate
                  </>
                )}
              </button>
            </>
          )}
        </div>
      )}
    </div>
  );
}

